export const moteGradientMap = {
  classic: 'white',
  mulberry: 'linear-gradient(134.94deg, #AA0CE9 0%, #6637E9 100%)'
} as const

export const moteThemes = {
  classic: {
    createdByName: '#212228',
    niceTitle: '#212228',
    background: 'white',
    border: '1px solid #D1D1D1',
    button: {
      color: '#212228',
      hover: {
        background: '#f6f6f9',
        color: '#212228'
      },
      active: {
        background: '#212228',
        color: '#ffffff'
      }
    },
    scrubber: {
      track: {
        empty: { background: 'rgba(33, 34, 40, 0.2)' },
        filled: { background: '#ac0ae8' }
      },
      thumb: { background: '#ac0ae8' },
      tooltip: { color: '#ffffff', background: '#212228' }
    },
    logo: {
      color: '#ac0ae8',
      secondaryColor: '#ffffff'
    },
    waveForm: {
      background: 'rgba(172,10,232,0.2)',
      mixBlendMode: 'normal',
      opacity: 0.2
    },
    pausedState: {
      text: '#212228'
    },
    translation: {
      icon: {
        color: '#212228'
      }
    },
    transcription: {
      text: '#212228',
      icon: {
        color: '#212228',
        hover: {
          background: '#f6f6f9',
          svg: {
            color: '#212228'
          }
        },
        active: {
          background: '#212228',
          svg: {
            color: 'white'
          }
        }
      }
    },
    menu: {
      icon: {
        color: '#212228',
        hover: {
          background: '#f6f6f9',
          svg: {
            color: '#212228'
          }
        },
        active: {
          background: '#212228',
          svg: {
            color: 'white'
          }
        }
      }
    }
  },
  mulberry: {
    createdByName: '#ffffff',
    niceTitle: '#ffffff',
    background: 'linear-gradient(129.17deg, #AC0AE8 0%, #0A70E8 223.26%)',
    border: '1px solid transparent',
    button: {
      color: '#ffffff',
      hover: {
        background: 'rgba(33, 34, 40, 0.2)',
        color: '#ffffff'
      },
      active: {
        background: '#212228',
        color: '#ffffff'
      }
    },
    scrubber: {
      track: {
        empty: { background: 'rgba(255, 255, 255, 0.2)' },
        filled: { background: '#ffffff' }
      },
      thumb: { background: '#ffffff' },
      tooltip: { color: '#212228', background: '#ffffff' }
    },
    logo: {
      color: '#ffffff',
      secondaryColor: '#ac0ae8'
    },
    waveForm: {
      background: 'rgba(255, 255, 255, 0.5)',
      mixBlendMode: 'soft-light',
      opacity: 0.5
    },
    pausedState: {
      text: 'white'
    },
    translation: {
      icon: {
        color: 'white'
      }
    },
    transcription: {
      text: 'white',
      icon: {
        color: 'white',
        hover: {
          background: 'rgba(33, 34, 40, 0.2)',
          svg: {
            color: 'white'
          }
        },
        active: {
          background: '#212228',
          svg: {
            color: 'white'
          }
        }
      }
    },
    menu: {
      icon: {
        color: '#ffffff',
        hover: {
          background: 'rgba(33, 34, 40, 0.2)',
          svg: {
            color: 'white'
          }
        },
        active: {
          background: '#212228',
          svg: {
            color: 'white'
          }
        }
      }
    }
  }
} as const
